export default "__VITE_ASSET__DL7o_Uva__"